/* Everyday Sling Carrier – landing page (Copper Pearl)
   Handles: color switching between products, variant/stock state,
   material-specific copy, gallery, Add to Cart, sticky bar. */
(function () {
  var VERSION = 'v9 (test certificate pop-up)';
  console.log('[Sling] script ' + VERSION + ' loaded');

  function init(root) {
    if (root.dataset.slReady) return;
    root.dataset.slReady = '1';

    var mainImg = root.querySelector('[data-sl-main-img]');
    var thumbsEl = root.querySelector('[data-sl-thumbs]');

    /* Gallery works on its own, even if the color data below can't load */
    var thumbsWrap = root.querySelector('[data-sl-thumbs-wrap]');
    var prevBtn = root.querySelector('[data-sl-prev]');
    var nextBtn = root.querySelector('[data-sl-next]');
    var currentIndex = 0;

    function thumbList() { return root.querySelectorAll('[data-sl-thumb]'); }

    // Show the fade only while more thumbnails are hidden past the end
    function updateFade() {
      if (!thumbsWrap || !thumbsEl) return;
      var el = thumbsEl;
      var moreDown = el.scrollHeight - el.clientHeight - el.scrollTop > 2;
      var moreRight = el.scrollWidth - el.clientWidth - el.scrollLeft > 2;
      thumbsWrap.classList.toggle('has-more', moreDown || moreRight);
    }

    // Keep the active thumbnail in view inside the scrolling strip
    function revealThumb(th) {
      if (!thumbsEl || !th) return;
      var el = thumbsEl;
      if (el.scrollHeight > el.clientHeight + 2) {
        var top = th.offsetTop, bottom = top + th.offsetHeight;
        if (top < el.scrollTop) el.scrollTo({ top: top, behavior: 'smooth' });
        else if (bottom > el.scrollTop + el.clientHeight) el.scrollTo({ top: bottom - el.clientHeight, behavior: 'smooth' });
      } else if (el.scrollWidth > el.clientWidth + 2) {
        var left = th.offsetLeft, right = left + th.offsetWidth;
        if (left < el.scrollLeft) el.scrollTo({ left: left, behavior: 'smooth' });
        else if (right > el.scrollLeft + el.clientWidth) el.scrollTo({ left: right - el.clientWidth, behavior: 'smooth' });
      }
    }

    function refreshGalleryUi() {
      var n = thumbList().length;
      if (prevBtn) prevBtn.hidden = n < 2;
      if (nextBtn) nextBtn.hidden = n < 2;
      currentIndex = 0;
      if (thumbsEl) { thumbsEl.scrollTop = 0; thumbsEl.scrollLeft = 0; }
      updateFade();
    }

    function go(step) {
      var list = thumbList();
      if (list.length < 2) return;
      var i = (currentIndex + step + list.length) % list.length;
      showThumb(list[i]);
    }

    function showThumb(th) {
      if (!mainImg || !th) return;
      currentIndex = parseInt(th.getAttribute('data-sl-thumb'), 10) || 0;
      revealThumb(th);
      if (th.dataset.src) mainImg.src = th.dataset.src;
      mainImg.srcset = th.dataset.srcset || '';
      if (th.dataset.w) mainImg.width = parseInt(th.dataset.w, 10);
      if (th.dataset.h) mainImg.height = parseInt(th.dataset.h, 10);
      mainImg.alt = th.dataset.alt || '';
      root.querySelectorAll('[data-sl-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === th); });
    }
    root.addEventListener('click', function (e) {
      var th = e.target.closest('[data-sl-thumb]');
      if (th && root.contains(th)) { showThumb(th); return; }
      if (e.target.closest('[data-sl-prev]')) { go(-1); return; }
      if (e.target.closest('[data-sl-next]')) { go(1); }
    });

    // Swipe the main image on touch screens
    var mainBox = root.querySelector('.sl-gallery__main');
    if (mainBox) {
      var startX = null, startY = null;
      mainBox.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
      }, { passive: true });
      mainBox.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    if (thumbsEl) thumbsEl.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);
    window.addEventListener('load', updateFade);
    refreshGalleryUi();

    /* ---------- Test certificate pop-up ---------- */
    var certDialog = root.querySelector('[data-sl-cert]');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-sl-cert-open]')) {
        e.preventDefault();
        if (!certDialog) return;
        var img = certDialog.querySelector('[data-sl-cert-img]');
        if (img) img.loading = 'eager';
        if (typeof certDialog.showModal === 'function') {
          certDialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        } else {
          var full = certDialog.querySelector('.sl-cert__full');
          if (full) window.open(full.href, '_blank', 'noopener');
        }
        return;
      }
      if (certDialog && (e.target.closest('[data-sl-cert-close]') || e.target === certDialog)) {
        certDialog.close();
      }
    });
    if (certDialog) {
      certDialog.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    }

    function all(sel) { return root.querySelectorAll(sel); }
    var variantInput = root.querySelector('[data-sl-variant-input]');
    var errorEl = root.querySelector('[data-sl-error]');
    var addAction = root.dataset.addAction || 'drawer';
    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var state = { color: null, variant: null };
    all('[data-sl-atc]').forEach(function (b) {
      var label = b.querySelector('[data-sl-atc-label]');
      if (label) b.dataset.slLabel = label.textContent;
    });

    /* ---------- Add to Cart ----------
       Same setup as the working Add to Cart on your other product page:
       add via /cart/add.js, then fire the theme's own events so its
       cart drawer refreshes and opens. */
    function resetButtons() {
      all('[data-sl-atc]').forEach(function (b) { b.classList.remove('is-loading'); });
      if (state.variant && state.color) { renderAtc(state.variant, state.color); return; }
      // Color data unavailable: put the original labels back
      all('[data-sl-atc]').forEach(function (b) {
        b.disabled = false;
        var label = b.querySelector('[data-sl-atc-label]');
        if (label && b.dataset.slLabel) label.textContent = b.dataset.slLabel;
      });
    }

    function setButtonsLabel(text) {
      all('[data-sl-atc]').forEach(function (b) {
        b.disabled = true;
        var label = b.querySelector('[data-sl-atc-label]');
        if (label) label.textContent = text;
      });
    }

    async function addToCart(btn) {
      if (state.variant && !state.variant.available) return;
      var variantId = state.variant ? state.variant.id : parseInt(variantInput.value, 10);
      if (!variantId) { console.error('[Sling] No variant ID found for Add to Cart.'); return; }
      if (errorEl) errorEl.hidden = true;
      all('[data-sl-atc]').forEach(function (b) { b.classList.add('is-loading'); });
      setButtonsLabel('Adding…');

      try {
        var response = await fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        });

        if (response.ok) {
          var data = await response.json();
          console.log('[Sling] Added to cart:', variantId);

          if (addAction === 'cart' || addAction === 'checkout') {
            window.location.href = routesRoot + addAction;
            return;
          }

          all('[data-sl-atc]').forEach(function (b) { b.classList.remove('is-loading'); });
          setButtonsLabel('✓ Added!');

          // Theme cart drawer refresh triggers (same as your other product page)
          document.dispatchEvent(new CustomEvent('theme:product:add', {
            detail: { response: data, button: btn },
            bubbles: true
          }));
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            detail: { button: btn },
            bubbles: true
          }));

          setTimeout(resetButtons, 3000);
        } else {
          var err = await response.json().catch(function () { return {}; });
          resetButtons();
          if (errorEl) {
            errorEl.textContent = err.description || err.message || 'Could not add to cart. Please try again.';
            errorEl.hidden = false;
          }
        }
      } catch (e) {
        console.error('[Sling] Add to Cart failed:', e);
        resetButtons();
        if (errorEl) { errorEl.textContent = 'Something went wrong. Please try again.'; errorEl.hidden = false; }
      }
    }

    root.addEventListener('click', function (e) {
      var atc = e.target.closest('[data-sl-atc]');
      if (!atc || !root.contains(atc)) return;
      e.preventDefault();
      if (atc.disabled || atc.classList.contains('is-loading')) return;
      addToCart(atc);
    });
    console.log('[Sling] ' + VERSION + ' ready. Add to Cart is active.');

    var dataEl = root.querySelector('[data-sl-data]');
    if (!dataEl) { console.error('[Sling] Color data block missing.'); return; }
    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch (e) {
      var m = /position (\d+)/.exec(e.message);
      var at = m ? parseInt(m[1], 10) : 0;
      console.error('[Sling] Color data could not be read: ' + e.message +
        '\nNear: ' + dataEl.textContent.slice(Math.max(0, at - 80), at + 40));
      return;
    }

    var colors = data.colors || [];
    var materials = data.materials || {};
    if (!colors.length) { console.warn('[Sling] No Color blocks have a product selected.'); return; }

    var variantsWrap = root.querySelector('[data-sl-variants]');
    var variantList = root.querySelector('[data-sl-variant-list]');
    var optionNameEl = root.querySelector('[data-sl-option-name]');

    function findColor(handle) {
      for (var i = 0; i < colors.length; i++) if (colors[i].handle === handle) return colors[i];
      return null;
    }
    function findVariant(color, id) {
      for (var i = 0; i < color.variants.length; i++) if (color.variants[i].id === id) return color.variants[i];
      return null;
    }
    function firstAvailable(color) {
      for (var i = 0; i < color.variants.length; i++) if (color.variants[i].available) return color.variants[i];
      return color.variants[0];
    }
    function colorAvailable(color) {
      for (var i = 0; i < color.variants.length; i++) if (color.variants[i].available) return true;
      return false;
    }
    function setText(sel, text) { all(sel).forEach(function (el) { el.textContent = text; }); }

    /* ---------- Rendering ---------- */
    function renderPrice(v) {
      setText('[data-sl-price]', v.price);
      all('[data-sl-compare]').forEach(function (el) {
        if (v.compare) { el.textContent = v.compare; el.hidden = false; } else { el.hidden = true; }
      });
      all('[data-sl-save]').forEach(function (el) {
        if (v.save > 0) { el.textContent = 'Save ' + v.save + '%'; el.hidden = false; } else { el.hidden = true; }
      });
    }

    function renderAtc(v, color) {
      all('[data-sl-atc]').forEach(function (btn) {
        btn.disabled = !v.available;
        var label = btn.querySelector('[data-sl-atc-label]');
        if (!label) return;
        if (!v.available) { label.textContent = 'Sold out'; return; }
        if (btn.hasAttribute('data-sl-atc-main')) label.textContent = 'Add to Cart · ' + v.price;
        else if (btn.classList.contains('sl-btn--final')) label.textContent = 'Add to Cart · ' + color.name;
        else label.textContent = 'Add to Cart';
      });
      all('[data-sl-soldout-tag]').forEach(function (el) { el.hidden = v.available; });
    }

    function renderMaterial(color) {
      // Details & Care accordions: show only the selected material's panel
      all('[data-sl-mat-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-sl-mat-panel') !== color.material;
      });
      var m = materials[color.material];
      if (!m) return;
      all('[data-sl-mat]').forEach(function (el) {
        var key = el.getAttribute('data-sl-mat');
        if (!(key in m)) return;
        var val = m[key] || '';
        el.textContent = val;
        if (key.indexOf('bullet_') === 0 && el.parentElement) el.parentElement.hidden = !val;
      });
      var img = root.querySelector('[data-sl-mat-img]');
      var ph = root.querySelector('[data-sl-mat-img-placeholder]');
      if (img && m.fabric_image) {
        img.src = m.fabric_image;
        img.hidden = false;
        if (ph) ph.hidden = true;
      }
    }

    function setMainImage(image) {
      if (!mainImg || !image) return;
      mainImg.src = image.s1200;
      mainImg.srcset = image.s600 + ' 600w, ' + image.s900 + ' 900w, ' + image.s1200 + ' 1200w';
      if (image.w) mainImg.width = image.w;
      if (image.h) mainImg.height = image.h;
      mainImg.alt = image.alt || '';
    }

    function renderGallery(color) {
      if (!thumbsEl) return;
      thumbsEl.innerHTML = '';
      color.images.forEach(function (image, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sl-thumb' + (i === 0 ? ' is-active' : '');
        b.setAttribute('data-sl-thumb', String(i));
        b.setAttribute('data-src', image.s1200);
        b.setAttribute('data-srcset', image.s600 + ' 600w, ' + image.s900 + ' 900w, ' + image.s1200 + ' 1200w');
        if (image.w) b.setAttribute('data-w', String(image.w));
        if (image.h) b.setAttribute('data-h', String(image.h));
        b.setAttribute('data-alt', image.alt || '');
        b.setAttribute('aria-label', 'Show image ' + (i + 1));
        var im = document.createElement('img');
        im.src = image.thumb; im.alt = ''; im.width = 100; im.height = 100; im.loading = 'lazy';
        b.appendChild(im);
        thumbsEl.appendChild(b);
      });
      setMainImage(color.images[0]);
      refreshGalleryUi();
      // Final call-to-action image follows the selected color's first image
      var finalImg = root.querySelector('[data-sl-final-img]');
      var first = color.images[0];
      if (finalImg && first) {
        finalImg.src = first.s1200;
        finalImg.srcset = first.s600 + ' 600w, ' + first.s900 + ' 900w, ' + first.s1200 + ' 1200w';
        finalImg.alt = first.alt || '';
      }
    }

    function renderVariants(color) {
      if (!variantsWrap || !variantList) return;
      var real = color.variants.length > 1;
      variantsWrap.hidden = !real;
      variantList.innerHTML = '';
      if (!real) return;
      if (optionNameEl) optionNameEl.textContent = color.optionName + ':';
      color.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sl-pill' + (v.id === state.variant.id ? ' is-selected' : '') + (v.available ? '' : ' is-soldout');
        b.setAttribute('data-sl-variant', String(v.id));
        b.setAttribute('aria-pressed', v.id === state.variant.id ? 'true' : 'false');
        b.textContent = v.title + (v.available ? '' : ' – sold out');
        variantList.appendChild(b);
      });
    }

    function renderSwatches(color) {
      all('[data-sl-swatch]').forEach(function (el) {
        var on = el.getAttribute('data-sl-swatch') === color.handle;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      setText('[data-sl-color-name]', color.name);
      if (color.title) setText('[data-sl-title]', color.title);
      var dot = root.querySelector('[data-sl-sticky-dot]');
      if (dot) dot.style.background = color.swatch;
    }

    function selectVariant(v) {
      state.variant = v;
      variantInput.value = v.id;
      renderPrice(v);
      renderAtc(v, state.color);
      if (errorEl) errorEl.hidden = true;
    }

    function selectColor(handle, opts) {
      var color = findColor(handle);
      if (!color) return;
      var sameColor = state.color && state.color.handle === color.handle;
      state.color = color;
      var v = findVariant(color, color.initialVariant) || firstAvailable(color);
      if (!v.available) v = firstAvailable(color);
      renderSwatches(color);
      selectVariant(v);
      renderVariants(color);
      renderMaterial(color);
      if (!opts || !opts.initial) {
        if (!sameColor) renderGallery(color);
        try {
          var url = color.url + window.location.search;
          window.history.replaceState({}, '', url);
        } catch (e) {}
      }
    }

    /* ---------- Events ---------- */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-sl-swatch]');
      if (sw && root.contains(sw)) { selectColor(sw.getAttribute('data-sl-swatch')); return; }

      var pill = e.target.closest('[data-sl-variant]');
      if (pill && root.contains(pill) && state.color) {
        var v = findVariant(state.color, parseInt(pill.getAttribute('data-sl-variant'), 10));
        if (v) { selectVariant(v); renderVariants(state.color); }
      }
    });

    /* ---------- Sticky bar ---------- */
    var sticky = root.querySelector('[data-sl-sticky]');
    var mainAtc = root.querySelector('[data-sl-atc-main]');
    var finalEl = root.querySelector('[data-sl-final]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var mainVisible = true, finalVisible = false, mainAbove = false;
      var update = function () {
        var show = !mainVisible && mainAbove && !finalVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var btn = sticky.querySelector('[data-sl-atc]');
        if (btn) btn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          mainVisible = en.isIntersecting;
          mainAbove = en.boundingClientRect.top < 0;
        });
        update();
      }).observe(mainAtc);
      if (finalEl) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { finalVisible = en.isIntersecting; });
          update();
        }).observe(finalEl);
      }
    }

    /* ---------- Start ---------- */
    var start = findColor(data.current) || colors[0];
    state.color = start;
    selectColor(start.handle, { initial: true });
    // Colors that are fully sold out keep their crossed-out swatch
    all('[data-sl-swatch]').forEach(function (el) {
      var c = findColor(el.getAttribute('data-sl-swatch'));
      if (c) el.classList.toggle('is-soldout', !colorAvailable(c));
    });
  }

  function boot() { document.querySelectorAll('[data-sl-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-sl-root]');
    if (r) init(r);
  });
})();